import { AxiosError } from "axios";
import { HttpRequestPost } from "../../service";

export interface MerchantOrganisationSearch {
  Id: string;
  Name: string;
  LogoUrl?: string;
  Archived: boolean;
  ShopsCount: number;
}

export interface MerchantOrganisationSearchResponseModel {
  Organisations: MerchantOrganisationSearch[];
}

export interface SearchMerchantOrganisationRequestModel {
  Page: number;
  Size: number;
  Query: string;
}

export function getMerchantsList(
  body: SearchMerchantOrganisationRequestModel,
  success: (response: MerchantOrganisationSearchResponseModel) => void,
  failure: (error: AxiosError<any>) => void
): void {
  HttpRequestPost(
    `/admin/merchant/list`,
    () => undefined,
    (response: { Result: MerchantOrganisationSearchResponseModel } | MerchantOrganisationSearchResponseModel) => {
      // Handle both wrapped and unwrapped responses
      const data = (response as any).Result || response;
      success(data);
    },
    (error: any) => failure(error),
    true,
    body
  );
}
